// Design System · public entry point.
// Import CSS side-effects once at load.
import "./tokens/index.css";
import "./typography/fonts.css";
import "./typography/scale.css";
import "./components/base.css";

// Public component exports.
export * from "./components";
export * from "./shell";
export { useFeatureFlag } from "./useFeatureFlag";

// Theme keys — helper constants for callers.
export const DS_THEMES = /** @type {const} */ (["erf-operator", "erf-public", "platform"]);

/**
 * Compose the theme class for a themed wrapper element.
 * @param {"erf-operator"|"erf-public"|"platform"} theme
 * @returns {string}
 */
export function themeClass(theme) {
  return `ds-scope ds-theme-${theme}`;
}
